<div class="icon">
  @if (icon) {
    <i class="{{ value }}"></i>
  } @else {
    <img class="img-icon" [src]="value" alt="icon" />
  }
</div>
